import {
  SET_DISHES,
  SET_CURRENT_DISH,
  DELETE_DISH,
  SET_DISH_PRIORITIES,
} from '../actions/dish';

let initialState = {
  dishesData: [],
  currentDish: null,
  dishPriorities: [],
};

const dish = (state = initialState, action) => {
  switch (action.type) {
    case SET_DISHES:
      return {
        ...state,
        dishesData: action.payload,
      };

    case SET_CURRENT_DISH:
      return {
        ...state,
        currentDish: action.payload,
      };

    case DELETE_DISH: {
      const { dishesData } = state;
      const newDishData = dishesData.filter((dishData) => {
        return dishData.id !== action.payload;
      });

      return {
        ...state,
        dishesData: newDishData,
      };
    }

    case SET_DISH_PRIORITIES:
      return {
        ...state,
        dishPriorities: action.payload,
      };

    default:
      return state;
  }
};

export default dish;
